'use client';
import React from 'react';
import Section from '../../elements/Section';
import Title from '../../elements/Title';
import Content from '../../elements/Content';
import List, { ListItem } from '../../elements/List';
import Link from '../../components/Link';
import { classes, FINANCIAL_STATEMENTS } from './utils';

export default function Page() {
  return (
    <div className={classes.wrapper}>
      <Section>
        <Title>Financial Figures</Title>
        <Content>
          Below you can find the financial statements as published on the
          National Bank of Belgium (in Dutch).
        </Content>
        <List>
          {FINANCIAL_STATEMENTS.map((financialStatement, i) => (
            <ListItem key={i}>
              <Link href={financialStatement.href} target="_blank">
                {financialStatement.name}
              </Link>
            </ListItem>
          ))}
        </List>
        <Content>
          Source:{' '}
          <Link href="https://www.nbb.be/en/central-balance-sheet-office/consulting/application-consult/application">
            https://www.nbb.be/en/central-balance-sheet-office/consulting/application-consult/application
          </Link>
        </Content>
      </Section>
    </div>
  );
}
